import { render, staticRenderFns, recyclableRender, components } from "./storelist.vue?vue&type=template&id=3d8ea700&"
var renderjs
import script from "./storelist.vue?vue&type=script&lang=js&"
export * from "./storelist.vue?vue&type=script&lang=js&"
import style0 from "./storelist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/store/part/user/storelist.vue"
export default component.exports